import {useEffect,useState} from 'react';
import {Layout} from './components/Layout';
import {useStore} from './store';
import {useLanguage} from './i18n';
import {Home} from './pages/Home';
import {Catalog} from './pages/Catalog';
import {ProductPage} from './pages/Product';
import {Customizer} from './pages/Customizer';
import {Cart} from './pages/Cart';
import {Checkout} from './pages/Checkout';
import {Account,NotFound,PaymentResult,TrackingPage} from './pages/Misc';
import {JerseyLabAdmin} from './pages/JerseyLabAdmin';

export default function App(){
  const [,render]=useState(0);const {loading,error}=useStore();const {t}=useLanguage();
  useEffect(()=>{const change=()=>render(value=>value+1);addEventListener('popstate',change);return()=>removeEventListener('popstate',change)},[]);
  const path=location.pathname.replace(/\/+$/,'')||'/';
  if(path==='/admin')return <JerseyLabAdmin/>;
  if(loading)return <div className="splash"><img className="splash-logo" src="/assets/jerseylab-logo.png" alt="JerseyLab"/><strong className="splash-brand">Jersey<i>Lab</i></strong><p>{t('brandTagline')}</p><div className="splash-progress" aria-label={t('loading')}/></div>;
  if(error)return <div className="splash error"><img src="/assets/jerseylab-logo.png" alt=""/><h1>{t('loadError')}</h1><p>{error}</p><button onClick={()=>location.reload()}>{t('retry')}</button></div>;
  let page;
  if(path==='/')page=<Home/>;else if(path==='/catalogo')page=<Catalog key={location.search}/>;else if(path==='/carrito')page=<Cart/>;else if(path==='/checkout')page=<Checkout/>;else if(path==='/seguimiento')page=<TrackingPage/>;else if(path==='/cuenta')page=<Account/>;else if(path==='/pago/resultado')page=<PaymentResult/>;else if(path.startsWith('/producto/'))page=<ProductPage id={decodeURIComponent(path.slice('/producto/'.length))}/>;else if(path.startsWith('/personalizar/'))page=<Customizer id={decodeURIComponent(path.slice('/personalizar/'.length))}/>;else page=<NotFound/>;
  return <Layout>{page}</Layout>;
}
